import React, { useEffect } from 'react';

import { SettingScreenLayout } from '../../../features/settings/components/setting-screen-layout';
import { ManageBillingSection } from '../../../features/billing/components/billing-and-plans/manage-billing-section';
import { StorageBillingSection } from '../../../features/billing/components/billing-and-plans/storage-billing-section';
import { uiStore } from '../../../core/stores/ui-store';
import { useCurrentSpace } from '../../../hooks/use-current-space';

import styles from './billing-settings.route.module.scss';
export const BillingSettingsRoute: React.FC = () => {
  const space = useCurrentSpace();

  useEffect(() => {
    uiStore.showBack = true;

    uiStore.currentLocation = 'space.settings';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  useEffect(() => {
    space?.getBillingDetails();
    space?.getBillingHistory();
  }, [space]);

  return (
    <SettingScreenLayout title="Billing">
      <div className={styles['container']}>
        <StorageBillingSection space={space} />

        {space.hasSubscription() && space.subscription?.provider === 'paddle' && (
          <ManageBillingSection space={space} />
        )}
      </div>
    </SettingScreenLayout>
  );
};
